// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.21-13228(e057a02c07)-C21/09/2026-10:39:45-B21/09/2026-10:52:39' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.21-13228(e057a02c07)-C21/09/2026-10:39:45-B21/09/2026-10:52:39",
  branch: "production",
  latestTag: "8.0.21",
  revCount: "13228",
  shortHash: "e057a02c07",
  longHash: "e057a02c073d2c7030da4c408d855035279b4d2f",
  dateCommit: "21/09/2026-10:39:45",
  dateBuild: "21/09/2026-10:52:39",
  buildType: "Ansible",
  } ;
